/* bossa — vídeos editoriais: tocam quando aparecem na tela e pausam quando saem (economiza dados no 4G). */
(function () {
  var videos = document.querySelectorAll('video[data-bossa-autoplay]');
  if (!videos.length) return;
  function play(v) { if (!v.dataset.bossaSom) v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if (!('IntersectionObserver' in window)) { videos.forEach(play); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.isIntersecting ? play(e.target) : e.target.pause(); });
  }, { threshold: 0.25 });
  videos.forEach(function (v) { io.observe(v); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') videos.forEach(function (v) {
      var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) play(v);
    });
  });
})();

/* botão de som do vídeo de abertura: começa mudo (regra dos navegadores); um toque liga a trilha */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-bossa-som]'); if (!b) return;
  var v = b.parentElement.querySelector('video'); if (!v) return;
  var ligar = v.muted;
  v.muted = !ligar; v.dataset.bossaSom = ligar ? '1' : '';
  if (ligar) { v.volume = 0.8; v.play(); }
  b.setAttribute('aria-pressed', ligar ? 'true' : 'false');
  b.setAttribute('aria-label', ligar ? 'desligar som' : 'ligar som');
});

/* ===== PDP: barra de compra rápida (aparece quando o botão principal sai da tela) ===== */
(function () {
  var bar = document.querySelector('[data-bossa-sticky]');
  var main = document.querySelector('.productView .product-form__submit, .productView [name="add"]');
  if (!bar || !main) return;
  document.body.appendChild(bar);                        // fora de containers com transform/overflow
  bar.querySelector('[data-bossa-sticky-comprar]').addEventListener('click', function () { main.click(); });
  var io = new IntersectionObserver(function (e) {
    var fora = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
    bar.classList.toggle('is-on', fora); bar.setAttribute('aria-hidden', fora ? 'false' : 'true');
    document.body.classList.toggle('bossa-sticky-on', fora);
  });
  io.observe(main);
})();

/* ===== PDP: consulta de CEP (ViaCEP) — mostra cidade e prazo ===== */
(function () {
  var box = document.querySelector('[data-bossa-entrega]'); if (!box) return;
  var input = box.querySelector('[data-bossa-cep]'), out = box.querySelector('[data-bossa-cep-resultado]');
  input.addEventListener('input', function () {
    var v = input.value.replace(/\D/g, '').slice(0, 8);
    input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  });
  box.querySelector('form').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var cep = input.value.replace(/\D/g, '');
    if (cep.length !== 8) { out.textContent = 'digite os 8 números do CEP.'; return; }
    out.textContent = 'consultando…';
    fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }).then(function (d) {
      if (d.erro) { out.textContent = 'não encontramos esse CEP. confere pra gente?'; return; }
      var lugar = (d.bairro ? d.bairro + ', ' : '') + d.localidade + '/' + d.uf;
      out.innerHTML = '<strong>chega em ' + lugar + ' em 5 a 7 dias úteis</strong><span>frete grátis · enviado com rastreio</span>';
    }).catch(function () { out.textContent = 'frete grátis para todo o Brasil · 5 a 7 dias úteis'; });
  });
})();

/* ===== "levar junto": adiciona ao carrinho sem sair da página e abre o carrinho ===== */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-bossa-levar]'); if (!b) return;
  var txt = b.textContent; b.disabled = true; b.textContent = 'separando…';
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: +b.dataset.bossaLevar, quantity: 1 }] }) })
    .then(function (r) { if (!r.ok) throw r; return r.json(); })
    .then(function () {
      b.textContent = 'no carrinho ✓';
      var abrir = document.querySelector('[data-cart-sidebar], .header__icon--cart, a[href$="/cart"]');
      if (abrir) abrir.click(); else location.href = '/cart';
    })
    .catch(function () { b.textContent = txt; b.disabled = false; location.href = '/cart'; });
});
